import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinhinnjewadi() {



  const cardData = {
"keyword": "Bus on Rent in Hinjewadi",

"headingDescription":
  "Aaradhya Travels offers reliable Bus on Rent in Hinjewadi, Pune for corporate office travel, IT company staff transportation, weddings, school trips, college tours, airport transfers, and outstation group journeys. Our fleet includes well-maintained AC and Non-AC buses in multiple seating capacities such as 20, 25, 32, 40, and 50-seaters. With professional drivers experienced in Hinjewadi IT Park routes and Pune highways, we ensure safe, punctual, and comfortable group travel with doorstep pickup from Hinjewadi Phase 1, 2, 3 and nearby areas.",

"topPlaces": [
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},

{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "Bus on Rent Hire in Wakad",
    description: "Bus on rent hire in Wakad service provides reliable transportation for weddings, airport transfers, family outings, corporate travel, and outstation journeys. Spacious buses and comfortable seating ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wakad Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus on Rent in Hinjewadi for Corporate Outing",
    description: "Bus on rent in Hinjewadi for corporate outing service offers professional transportation for office trips, employee outings, conferences, team-building activities, and business travel. Spacious seating and smooth travel performance ensure comfortable journeys suitable for IT professionals and office teams. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient corporate outing bus reservations."
  },
  {
    name: "Bus on Rent in Hinjewadi for Outstation",
    description: "Bus on rent in Hinjewadi for outstation service provides dependable long-distance transportation for Goa tours, family vacations, pilgrimage journeys, sightseeing trips, and tourist travel. Spacious buses and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, IT parks, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "Bus Hire for Wedding Hinjewadi",
    description: "Bus hire for wedding Hinjewadi service offers comfortable transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Bharat Benz 35 Seater Bus in Hinjewadi",
    description: "Bharat Benz 35 seater bus in Hinjewadi service provides premium transportation for corporate events, educational tours, family vacations, airport transfers, and outstation journeys. Spacious luxury seating and modern interiors ensure comfortable travel experiences suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and airports across Hinjewadi Pune. Flexible booking options allow convenient Bharat Benz bus reservations."
  },
  {
    name: "Urbania Luxury Mini Bus in Hinjewadi",
    description: "Urbania luxury mini bus in Hinjewadi service offers stylish premium transportation for airport transfers, office outings, sightseeing journeys, family vacations, and outstation travel. Spacious interiors and comfortable luxury seating ensure smooth travel experiences suitable for corporate and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, homes, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient Urbania mini bus reservations."
  },
  {
    name: "Corporate Outing Bus Hire Hinjewadi",
    description: "Corporate outing bus hire Hinjewadi service provides professional transportation for employee recreation trips, office outings, conferences, team-building events, and company travel. Spacious buses and comfortable interiors ensure pleasant journeys suitable for corporate teams and business passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient corporate outing bus reservations."
  },
  {
    name: "Tempo Traveller Hire Hinjewadi",
    description: "Tempo Traveller hire Hinjewadi service offers comfortable transportation for sightseeing tours, airport pickups, office travel, family outings, and outstation journeys. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Mini Bus on Rent Hinjewadi",
    description: "Mini bus on rent Hinjewadi service provides dependable transportation for educational tours, family functions, airport transfers, office outings, and local or outstation travel. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Bus Hire for Marriage Hinjewadi",
    description: "Bus hire for marriage Hinjewadi service offers reliable transportation for wedding ceremonies, bridal parties, family members, and guest travel requirements. Spacious buses and comfortable seating ensure smooth travel experiences suitable for marriage celebrations and family gatherings. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient marriage bus reservations."
  },
  {
    name: "Hinjewadi Phase 1 Bus on Rent",
    description: "Hinjewadi Phase 1 bus on rent service provides comfortable transportation for IT employees, airport transfers, office outings, educational tours, and family travel requirements. Spacious seating and smooth travel performance ensure pleasant journeys suitable for local and outstation travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Hinjewadi Phase 1 Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Hinjewadi Phase 2 Bus on Rent",
    description: "Hinjewadi Phase 2 bus on rent service offers dependable transportation for corporate travel, family outings, airport pickups, sightseeing tours, and educational trips. Spacious buses and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial areas across Hinjewadi Phase 2 Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Hinjewadi Phase 3 Bus on Rent",
    description: "Hinjewadi Phase 3 bus on rent service provides reliable transportation for office outings, employee movement, airport transfers, weddings, and outstation journeys. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for corporate and family groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Hinjewadi Phase 3 Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Bus Hire Baner Nearby",
    description: "Bus hire Baner nearby service offers comfortable transportation for weddings, airport transfers, educational tours, office outings, and sightseeing journeys. Spacious buses and luggage space ensure smooth travel experiences suitable for local and outstation travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Baner Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire Aundh Nearby",
    description: "Bus hire Aundh nearby service provides dependable transportation for family outings, business travel, airport pickups, educational tours, and wedding functions. Spacious seating and comfortable interiors ensure pleasant journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Aundh Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire Balewadi Nearby",
    description: "Bus hire Balewadi nearby service offers reliable transportation for sightseeing journeys, office outings, airport transfers, family trips, and outstation travel. Spacious buses and smooth travel performance ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Balewadi Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire Wakad Nearby",
    description: "Bus hire Wakad nearby service provides comfortable transportation for weddings, educational tours, office travel, airport transfers, and family functions. Spacious seating and luggage capacity ensure smooth travel experiences suitable for local and long-distance journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wakad Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Bus Hire for IT Companies Hinjewadi",
    description: "Bus hire for IT companies Hinjewadi service offers professional transportation for employee movement, office shuttle services, business meetings, conferences, and corporate outings. Spacious buses and comfortable seating ensure smooth journeys suitable for IT professionals and executive teams. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient IT company bus reservations."
  },
  {
    name: "Bus Hire for Airport Transfer Hinjewadi",
    description: "Bus hire for airport transfer Hinjewadi service provides reliable transportation for tourists, corporate guests, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage space ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and Pune Airport across Hinjewadi Pune. Flexible booking options allow convenient airport bus reservations."
  },
  {
    name: "Bus Hire for Pune to Mumbai Hinjewadi",
    description: "Bus hire for Pune to Mumbai Hinjewadi service offers dependable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious buses and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient Pune to Mumbai bus reservations."
  }
],

tableData: [
  ["Bus on Rent Hire in Wakad", "Bus on Rent in Hinjewadi for Corporate Outing"],
  ["Bus on Rent in Hinjewadi for Outstation", "Bus Hire for Wedding Hinjewadi"],
  ["Bharat Benz 35 Seater Bus in Hinjewadi", "Urbania Luxury Mini Bus in Hinjewadi"],
  ["Corporate Outing Bus Hire Hinjewadi", "Tempo Traveller Hire Hinjewadi"],
  ["Mini Bus on Rent Hinjewadi", "Bus Hire for Marriage Hinjewadi"],
  ["Hinjewadi Phase 1 Bus on Rent", "Hinjewadi Phase 2 Bus on Rent"],
  ["Hinjewadi Phase 3 Bus on Rent", "Bus Hire Baner Nearby"],
  ["Bus Hire Aundh Nearby", "Bus Hire Balewadi Nearby"],
  ["Bus Hire Wakad Nearby", "Bus Hire for IT Companies Hinjewadi"],
  ["Bus Hire for Airport Transfer Hinjewadi", "Bus Hire for Pune to Mumbai Hinjewadi"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Bus on Rent in Hinjewadi",
        WhyChoosedescription: "Aaradhya Travels provides reliable bus rental service in Hinjewadi with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate travel, family tours, and group transportation."
      },
      {
        WhyChooseheading: "Affordable Bus Rental Packages in Hinjewadi",
        WhyChoosedescription: "Aaradhya Travels offers affordable bus on rent in Hinjewadi with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Hinjewadi",
        WhyChoosedescription: "Our bus rental service in Hinjewadi operates 24 hours for employee transportation, airport transfers, weddings, corporate outings, school trips, and outstation group travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Bus Options",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses suitable for corporate teams, family groups, schools, and tourists."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Hinjewadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Hinjewadi Phase 1, Phase 2, Phase 3, Wakad, Baner, Balewadi, Marunji, Tathawade, and nearby IT parks for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is bus on rent in Hinjewadi?", answer: "Bus rental service in Hinjewadi provides comfortable group transportation for corporate travel, employee transport, family tours, school trips, and outstation journeys." },
    { question: "Is bus booking available 24 hours in Hinjewadi?", answer: "Yes, Aaradhya Travels provides 24/7 bus rental service in Hinjewadi." },
    { question: "Which seating capacity buses are available?", answer: "Aaradhya Travels offers 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses for group travel requirements." },
    { question: "Can I book buses for outstation travel from Hinjewadi?", answer: "Yes, customers can book buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Hinjewadi." },
    { question: "Do you provide buses for corporate events in Hinjewadi?", answer: "Yes, Aaradhya Travels provides bus rental service for corporate meetings, office outings, conferences, and employee transportation in Hinjewadi." },
    { question: "Are AC and Non-AC buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly group travel." },
    { question: "Can I book bus rental service online in Hinjewadi?", answer: "Yes, customers can easily book bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family functions?", answer: "Yes, Aaradhya Travels provides spacious buses suitable for weddings, family vacations, and group events." },
    { question: "Are bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Patil",
      feedback:
        "Booked bus on rent in Hinjewadi with Aaradhya Travels for our corporate outing. Comfortable bus, punctual service, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent bus rental service in Hinjewadi. Clean vehicle, affordable pricing, and smooth travel experience for our family group tour.",
      rating: 5
    }
  ];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Hinjewadi",
  "image": "https://www.aaradhyatravels99.com/assets/images/bus-on-rent-in-hinjewadi.jpg",
  "description": "Book Bus on rent in Hinjewadi with Aaradhya Travels for corporate outings, IT company transport, weddings, airport transfers, family trips, and outstation travel. Available in Urbania, Bharat Benz 35 seater, tempo traveller, mini bus, AC and Non-AC options.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3921"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/bus-on-rent-in-hinjewadi"
  }
};


  return (
    <div>


<Helmet>
  <title>
    Bus on Rent in Hinjewadi | Corporate & IT Company Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Bus on rent in Hinjewadi with Aaradhya Travels. Affordable Urbania, Bharat Benz 35 seater, tempo traveller, and mini bus available for IT companies, corporate outings, weddings, airport transfers, Wakad, and outstation trips."
  />

  <meta
    name="keywords"
    content="Bus on rent hire in Wakad, Bus on rent in Hinjewadi for corporate outing, Bus on rent in Hinjewadi for outstation, Bus hire for wedding Hinjewadi, Bharat Benz 35 seater bus in Hinjewadi, Urbania luxury mini bus in Hinjewadi, Corporate outing bus hire Hinjewadi, Tempo traveller hire Hinjewadi, Mini bus on rent Hinjewadi, Bus hire for marriage Hinjewadi, Hinjewadi phase 1 bus on rent"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinhinnjewadi;